import React from 'react';

const XOutlined = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
    >
        <path
            d="M11.025.672h2.147l-4.69 5.36L14 13.329H9.68L6.294 8.904l-3.87 4.424H.275L5.29 7.593 0 .673h4.43l3.057 4.042zm-.755 11.372h1.19L3.78 1.889H2.504z"
            fill="#fff"
        />
    </svg>
);
export default XOutlined;
